<template>
	<div class="back-navigation-container">
		<BaseBackButton title="Back"/>
	</div>
</template>

<script>
	export default {
		props: {
			backRoute: String,
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	@include desktop {
		.back-navigation-container {
			display: flex;
			position: sticky;
			top: 0;

			align-items: center;
			align-content: center;
			
			border-bottom: 1px solid $greyOutline;
			padding: 0 0;
	
			width: 100%;
			height: $navigationBarHeight;
			background-color: $checkoutBackgroundColor;
			z-index: $zTopInteractionLayer;
			.back-button-container {
				margin-left: 4rem;
			}
		}
		.side-bar {
			.back-navigation-container {
				.back-button-container {
					margin-left: 1em;
				}
			}
		}
	}
	@include mobile {
		.back-button-container {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/menu/BackNavigation.vue